import React, { type FC, useState } from "react";
import { ButtonText } from "@components/AuthFlow/Passwordless/ButtonText";
import { GoogleButton } from "@components/GoogleIdentity/GoogleButton";
import { withPrefix } from "@tracking/tracking";
import {
  screenNames,
  useScreenState,
} from "clientState/AuthFlow/providers/ScreenProvider";
import { Flex } from "@edreamsodigeo/prisma-design-system";

import type { IncentivizeMytripsLoginButtonsProps } from "./contract";

const { SIGNIN } = screenNames;

const IncentivizeMytripsLoginButtons: FC<
  IncentivizeMytripsLoginButtonsProps
> = ({
  signinLink,
  showSigninLink,
  googleButtonScreen,
  renderSigninScreen,
  renderPasswordlessScreen,
  mytripsLoginFlow,
}) => {
  const { state } = useScreenState();
  const [email] = useState(state.userData.email);

  const handleClick = (): void => {
    if (mytripsLoginFlow === SIGNIN) {
      renderPasswordlessScreen();
    } else {
      renderSigninScreen({ ...state.userData, email });
    }
  };

  return (
    <Flex flexDirection="column" gap="base" mt="base">
      {signinLink && (
        <ButtonText
          dataTestId="loginButton"
          type="secondary"
          trackingId={withPrefix(
            signinLink.trackingId || "",
            state.trackingPrefix,
          )}
          onClick={handleClick}
        >
          {signinLink.content}
        </ButtonText>
      )}

      {showSigninLink && (
        <GoogleButton
          screen={googleButtonScreen}
          trackingPrefix={state.trackingPrefix}
          gaTrackingPrefix={state.gaTrackingPrefix}
        />
      )}
    </Flex>
  );
};

export default IncentivizeMytripsLoginButtons;
